import(/* webpackMode: "eager" */ "/codebuild/output/src3008175825/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
